<a *ngIf="hasLink; else noLink" class="hilti-logo" href="/" [attr.aria-label]="'header.label.home' | i18next">
  <ng-container *ngTemplateOutlet="logo" />
</a>

<ng-template #noLink>
  <span class="hilti-logo"><ng-container *ngTemplateOutlet="logo" /></span>
</ng-template>

<ng-template #logo>
  <img [src]="'/assets/images/hilti-logo.svg' | assetPath" [alt]="'common.label.hiltiLogoAlt' | i18next" />
</ng-template>
